module.exports = __webpack_public_path__ + "img/class3.d43c46eb.png";